//@flow
import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import {CardColumns, Card, CardHeader, CardBlock} from "reactstrap";
import * as taskActions from '../../redux/tasks/actions';
import TaskCard from './TaskCard'
import WaitWithNote from '../common/WaitWithNote'

type ProjectTasks$Props = {
   auth: any,
   match: any,
   refreshTasksList: (jwt:any, taskCategoryId:any) => mixed,
   tasksListUIAcknowledge: () => mixed,
   taskSelect: (task: any) => mixed,
   taskDist: any,
   checkResumeTaskInfo: (jwt:any,taskId:any)=> mixed
}

type ProjectTasks$State = {
  refreshTasksTimerId: any
}


class ProjectTasks extends React.Component<ProjectTasks$Props,ProjectTasks$State> {
  state = {
     refreshTasksTimerId: null
  }

  componentDidMount(){
      this.refreshTasks();
  }

  componentWillUnmount(){
    if (this.state.refreshTasksTimerId){
      clearInterval(this.state.refreshTasksTimerId);
    }
  }

  refreshTasks(){
    const { auth,match } = this.props;
    const taskCategoryId=match.params.taskCategoryId;
    if (auth.jwtToken && taskCategoryId){
       this.props.refreshTasksList(auth.jwtToken,taskCategoryId);
    }
  }

  componentWillMount(){
    this.props.tasksListUIAcknowledge();
    if (!this.state.refreshTasksTimerId){
      let refreshTasksTimerId = setInterval(() => {
          this.refreshTasks()
      },10000)
      this.setState({refreshTasksTimerId})
    }
  }

  taskClick(task){
    this.props.taskSelect(task);
  }

  render() {
    const { taskDist,auth } = this.props;

    if (taskDist.taskSelected){
      if (this.state.refreshTasksTimerId){
        clearInterval(this.state.refreshTasksTimerId);
      }
      
      if (this.props.taskDist.toCheckTaskBacklog){
        this.props.checkResumeTaskInfo(auth.jwtToken,taskDist.task.task_dist_id)
        return <WaitWithNote waitNote={'Please wait...'} />
      }

      return <Redirect to='/taskAcceptance' />;

    }

    const taskElements = taskDist.tasks.map((task)=>{
      return (
        <TaskCard taskClick={this.taskClick.bind(this)} key={task.id} task={task} auth={auth} {...this.props} />
      )
    })

    return (
      <div className="container">
        <div className='row'>
           <br />
        </div>   
        <div className="row">
              {taskElements}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    auth: state.auth,
    taskDist: state.taskDist
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    taskSelect: (task) => {
      dispatch(taskActions.taskSelect(task))
    },
    tasksListUIAcknowledge: () => {
      dispatch(taskActions.tasksListUIAcknowledge())
    },
    refreshTasksList: (jwt,taskCategoryId) => {
      dispatch(taskActions.refreshTasksList(jwt,taskCategoryId))
    },
    checkResumeTaskInfo: (jwt,taskId)=>{
      dispatch(taskActions.checkResumeTaskInfo(jwt,taskId))
    }
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(ProjectTasks);


// WEBPACK FOOTER //
// ./src/views/ProjectTasks/ProjectTasks.js